import { render, staticRenderFns } from "./SaveLayoutButton.vue?vue&type=template&id=d250e7f4"
import script from "./SaveLayoutButton.vue?vue&type=script&lang=js"
export * from "./SaveLayoutButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports